import React from 'react'
import StatusItem from './StatusItem';

import '../../../styles/scss/ProgressBar.scss';

function StatusBar(props) {

    //Parametros de entrada.
    const inputParam_StatusList = props.statusList;
    const inputParam_StatusId = props.statusId;
    const inputParam_StatusKeyField = props.statusKeyField;
    const inputParam_StatusValueField = props.statusValueField;

    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.

    //Render de componente.
    return (
        <>
        <ol className="steps" style={{paddingTop: "0px !important"}}>
            {
                inputParam_StatusList.map((status, index) =>
                    <StatusItem key={index} index={index + 1} status={status} statusId={inputParam_StatusId} statusKeyField={inputParam_StatusKeyField} statusValueField={inputParam_StatusValueField} />
                )
            }
        </ol>
        </>
    );
}

export default StatusBar;
